/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum MODEL_ATTRS_LIST {
  NAME = "name",
  DESCRIPTION = "description",
}
